var generic = generic || {};
var presentAfterpay = presentAfterpay || {};
var apConfig = apConfig || {};

(function ($) {
  Drupal.behaviors.productInstallmentPriceV1 = {
    locale: '',
    afterpayLibrary: 'https://static-us.afterpay.com/javascript/present-afterpay.js',
    priceSelector: '.js-price-installment',
    min: 3500,
    max: 100000,

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setup(context);
    },

    setup: function (context) {
      var self = this;

      self.locale = generic.cookie('LOCALE');
      var imported = document.createElement('script');
      var isUS = self.locale && self.locale === 'en_US';
      var hasAfterPay = $('.js-afterpay', context).length > 0 && isUS;

      imported.src = self.afterpayLibrary;
      document.head.appendChild(imported);
      if (!imported.readyState && hasAfterPay) {
        imported.onload = function () {
          self.initAfterPay(context);
        };
      }
    },

    initAfterPay: function (context) {
      var self = this;
      var amount = null;

      presentAfterpay.afterpayConfig = function (amount) {
        var quantity = $('.js-product-qty-select', context).length
          ? $('.js-product-qty-select option:selected', context).val()
          : 1;
        var currency = window.utag_data ? window.utag_data.currency_code : 'USD';
        var $afterpayParagraph = $('.afterpay-paragraph', context);

        $afterpayParagraph.length ? $afterpayParagraph.remove() : '';
        apConfig = {
          priceSelector: self.priceSelector,
          locale: self.locale,
          currency: currency,
          showUpperLimit: true,
          replaceModalOpenIcon: 'i',
          amount: amount * quantity,
          minMaxThreshold: {
            min: self.min,
            max: self.max
          }
        };
        if (typeof presentAfterpay === 'function') {
          new presentAfterpay(apConfig).init();
        }
      };
      var $productPrice = $('.js-product-sku-price', context);

      if ($productPrice.length) {
        amount = $productPrice.find('span').html().replace('$', '').replace('.', '');
      }
      if (amount !== null) {
        presentAfterpay.afterpayConfig(amount);
      }
    },

    attached: false
  };
})(jQuery);
